/* ---------------------------------------

    -- スクロール連動はここ

--------------------------------------- */
export default class Pararax{
    constructor(){
        this.$target;
        this.start = false;/* trueで処理が開始される */
        this.paraPoint = [];

        this.scInc=0;
        /*  ステータスをセット */
        this.status = [];

    }
    init(){

        this.$target = document.querySelectorAll(".js__sc-para");

        if(this.$target[0]){
            this.start = true;
            for(let i in this.$target){
                if(this.$target[i].nodeType!=1) continue; // dom要素以外は処理止める
                this.status[i] = {
                    rate : this.$target[i].getAttribute('data-rate')*2,
                    type : ""
                }
                let _t;

                for(let j in this.$target[i].classList[0]){
                    if( typeof(this.$target[i].classList[j])!=="string" ) continue;
                    if(this.$target[i].classList[j].match(/js__dir-/g))  _t = this.$target[i].classList[j].replace("js__","");
                    this.status[i].type = _t;
                }
            }

        }else{
            this.start = false;

        }


    }
    mot(inc,progress,fpsRate){
        if(!this.start||!this.paraPoint[0]) return;
        this.scInc = inc;
        // this.scInc +=  0.01 * (inc - this.scInc)*fpsRate;


        for(let i in this.$target) {
            if (this.$target[i].nodeType != 1) break; // dom要素以外は処理止める
            if(this.paraPoint[i].start < inc && this.paraPoint[i].end > inc  ) {
                const pInc = ( this.scInc - this.paraPoint[i].start ) * this.status[i].rate;
                TweenLite.set(this.$target[i],{y:-pInc});
            }
        }




    }

    resize (winH) {
        this.paraPoint = [];
        for(let i in this.$target){
            if(this.$target[i].nodeType!=1) break; // dom要素以外は処理止める
            const rect =  this.$target[i].getBoundingClientRect();

            this.paraPoint[i] = {
                base  : rect.top,
                start : Math.max(0,rect.top + this.scInc - window.innerHeight),
                end   : rect.top + this.scInc + window.innerHeight*0.8,
            }

            let _size = window.innerWidth > 750 ? "pc":"sp";

                this.status[i].rate = _size == "pc" ? this.$target[i].getAttribute('data-rate')*2 : this.$target[i].getAttribute('data-rate');

            TweenLite.set(this.$target[i],{top:_size == "pc" ? window.innerHeight*this.status[i].rate:window.innerHeight*this.status[i].rate*0.85})

        }

    }


}